export default function replacePlaceholders(
  str: string,
  pathParts: Record<string, string>,
  processPlaceholder = placeholder =>
    pathParts[placeholder.slice(1, -1)] || placeholder
) {
  return str.replace(/{\S+}/g, processPlaceholder);
}
